<template>
  <v-container id="bid-equipment" fluid tag="section" class="main-container">
    <idc-component-bid-equipments
      :can-read="canRead"
      :can-edit="false"
      :can-delete="false"
      :url-specification="urlSpecification"
      :bid-number="bidNumber"
      :settings="settings"
    />
  </v-container>
</template>

<script>
  import Vue from 'vue'
  import Path from '@/utilities/bid/enums/Path'
  import { mapState } from 'vuex'

  export default Vue.extend({
    name: 'DashboardInactiveBidEquipment',
    components: {
      IdcComponentBidEquipments: () => import('@/components/idc/bids/specification/equipment/Equipments'),
    },
    props: {
      canRead: {
        type: Boolean,
        default: () => true,
      },
      urlSpecification: {
        type: String,
        default: () => Path.SALES_NO_BIDS_SPEC,
      },
      bidNumber: {
        type: String,
        validator(value) {
          return /^ID-\d{4}-\d{4}$/.test(value)
        },
        default: () => '',
      },
    },
    computed: {
      ...mapState('Settings', ['settings']),
    },
  })
</script>
